
import { useState } from 'react';
import Navigation from '../../components/base/Navigation';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    project: '',
    budget: '',
    message: '',
    timeline: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3v7o1955ieogu7sispg', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          project: '',
          budget: '',
          message: '',
          timeline: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-3xl font-light mb-12 tracking-wide">CONTACT</h1>
          
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-xl font-light mb-6">Contact Information</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-gray-400 text-sm mb-2">Email</h3>
                  <p className="text-white">Lennikendbd@gmail.com</p>
                </div>
                
                <div>
                  <h3 className="text-gray-400 text-sm mb-2">Phone</h3>
                  <p className="text-white">+84776105105</p>
                </div>
              </div>
              
              <div className="mt-8">
                <h3 className="text-gray-400 text-sm mb-4">Follow Me</h3>
                <div className="flex space-x-4">
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer">
                    <i className="ri-behance-line text-lg"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer">
                    <i className="ri-dribbble-line text-lg"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-gray-700 rounded-full transition-colors cursor-pointer">
                    <i className="ri-linkedin-line text-lg"></i>
                  </a>
                </div>
              </div>
            </div>
            
            <div>
              <h2 className="text-xl font-light mb-6">Send Message</h2>
              
              <form onSubmit={handleSubmit} id="contact-form" data-readdy-form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm text-gray-400 mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors"
                    placeholder="Enter your full name"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm text-gray-400 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors"
                    placeholder="email@example.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-sm text-gray-400 mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors"
                    placeholder="+84 123 456 789"
                  />
                </div>
                
                <div>
                  <label htmlFor="project" className="block text-sm text-gray-400 mb-2">
                    Project Type *
                  </label>
                  <select
                    id="project"
                    name="project"
                    value={formData.project}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 pr-8 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors appearance-none cursor-pointer"
                  >
                    <option value="">Select project type</option>
                    <option value="film-poster">Film Poster</option>
                    <option value="advertising-poster">Advertising Poster</option>
                    <option value="branding">Branding & Identity</option>
                    <option value="visual-identity">Visual Identity</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="budget" className="block text-sm text-gray-400 mb-2">
                    Estimated Budget
                  </label>
                  <select
                    id="budget"
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 pr-8 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors appearance-none cursor-pointer"
                  >
                    <option value="">Select budget range</option>
                    <option value="under-5m">Under $200</option>
                    <option value="5-10m">$200 - $400</option>
                    <option value="10-20m">$400 - $800</option>
                    <option value="over-20m">Over $800</option>
                    <option value="discuss">Discuss directly</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="timeline" className="block text-sm text-gray-400 mb-2">
                    Timeline
                  </label>
                  <select
                    id="timeline"
                    name="timeline"
                    value={formData.timeline}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 pr-8 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors appearance-none cursor-pointer"
                  >
                    <option value="">Select timeline</option>
                    <option value="urgent">Urgent (1-2 weeks)</option>
                    <option value="normal">Normal (3-4 weeks)</option>
                    <option value="flexible">Flexible (1-2 months)</option>
                    <option value="not-determined">Not determined</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-sm text-gray-400 mb-2">
                    Project Description *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-gray-500 transition-colors resize-none"
                    placeholder="Describe your project in detail, design requirements, desired style..."
                  />
                  <div className="text-xs text-gray-500 mt-1">
                    {formData.message.length}/500 characters
                  </div>
                </div>
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-white text-black py-3 px-6 rounded-lg font-medium hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
                
                {submitStatus === 'success' && (
                  <div className="p-4 bg-green-900/30 border border-green-700 rounded-lg text-green-300 text-sm">
                    Thank you! Your message has been sent successfully. I will respond within 24 hours.
                  </div>
                )}
                
                {submitStatus === 'error' && (
                  <div className="p-4 bg-red-900/30 border border-red-700 rounded-lg text-red-300 text-sm">
                    An error occurred while sending the message. Please try again or contact directly via email.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
